/* ============================================
   HAPPYLAND CREATIVE — CUSTOM
   Blog category filter 
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  const filterWrap = document.querySelector('.blog-filter');
  if (!filterWrap) return;

  const pills = filterWrap.querySelectorAll('.blog-filter__pill');
  const items = document.querySelectorAll('.blog-post-item');

  filterWrap.addEventListener('click', (event) => {
    const pill = event.target.closest('.blog-filter__pill');
    if (!pill) return;

    pills.forEach((p) => p.classList.remove('is-active'));
    pill.classList.add('is-active');

    const selected = pill.dataset.filterCategory;

    items.forEach((item) => {
      const matches = selected === 'all' || item.dataset.category === selected;
      item.classList.toggle('is-hidden', !matches);
    });
  });
});